import { ADVERSARIAL_HELPER_PATH } from 'constants/paths'
import AdversarialHelperPage from './components/AdversarialHelperPage'

// Sync route definition
export default {
  path: ADVERSARIAL_HELPER_PATH,
  component: AdversarialHelperPage
}
